export default "__VITE_ASSET__DeHopCHz__"